module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1161.3870df8e.png";